<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-基础设置
  -->
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">预约服务设置</div>
      <el-form-item label="开启余额充值">
        <el-radio v-model="form.is_open" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_open" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="充值比例">
        <el-input placeholder="请输入充值比例" type="number" v-model="form.recharge_ratio" class="max-w460">
          <template slot="prepend">1元可充值</template>
          <template slot="append">余额</template>
        </el-input>
      </el-form-item>
      <el-form-item label="自定义文字" :rules="[{required: true,message: ' '}]">
        <el-input type="textarea" rows="5" v-model="form.remark" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="开启充值有礼">
        <el-radio v-model="form.is_recharge_give" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_recharge_give" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="充值赠送">
        <el-input placeholder="请输入充值金额" type="number" v-model="form.recharge_money" class="max-w460">
          <template slot="prepend">充值</template>
          <template slot="append">余额</template>
        </el-input>
        <el-input placeholder="请输入赠送金额" type="number" v-model="form.give_money" class="max-w460">
          <template slot="prepend">赠送</template>
          <template slot="append">余额</template>
        </el-input>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import BalanceApi from '@/api/balance.js';
export default {
  data() {
    return {
      form: {
        is_open: 0,
        recharge_ratio: 1,
        remark: '',
        is_recharge_give: 0,
        recharge_money: 0,
        give_money: 0,
      },
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      BalanceApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.setting;
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      BalanceApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/balance/setting/index.vue